import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { routeNames } from '../../../shared/route-names';
import { UserService } from '../../user/services/user.service';

export const GuestGuard = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  return _handleGuestResult(userService.isLoggedIn(), router);
};

function _handleGuestResult(isLoggedIn: boolean, router: Router): boolean {
  if (isLoggedIn) {
    router.navigateByUrl(routeNames.home);
    return false;
  }
  
  return true;
}
